import { Module } from 'vuex'
import { GlobalProp } from '@/store'

export interface LoadState {
  loading: boolean | undefined
}

export const load: Module<LoadState, GlobalProp> = {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    SET_LOADING: (state, status) => {
      state.loading = status
    },
  },
  actions: {
    loadOn({ commit }, status) {
      commit('SET_LOADING', status)
    },
  },
  getters: {}
}
